module.exports = __webpack_public_path__ + "img/1440.cf3b7e51.jpg";